enum Role {
  SUPER = 'SUPER',
  ADMIN = 'ADMIN',
  PMO = 'PMO',
  CONTROLLERSHIP = 'CONTROLLERSHIP',
  SHARED = 'SHARED',
}

export default Role;
